import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'
import Vue from 'vue'
import tabbar from '@/components/tab-bar/tab-bar.vue'

Vue.config.productionTip = false

App.mpType = 'app'
uni.$u.config.unit = 'rpx'
Vue.use('tab-bar', tabbar);

// 引入全局 uView 框架
import uView from '@/uni_modules/uview-ui'
Vue.use(uView)

// 全局存储vuex的封装
import store from '@/store'
Vue.use(store)

// 请求相关
import {
	reqAll,
	reqGet,
	reqPost
} from '@/api/index.js';
Vue.prototype.$reqAll = reqAll;
Vue.prototype.$reqGet = reqGet;
Vue.prototype.$reqPost = reqPost;
// 由于微信小程序的运行机制问题，需声明如下一行，H5和APP非必填
const app = new Vue({
	store,
	...App
})
app.$mount()